import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// L'interrupteur « Modules ignorés » du sommaire de la fiche du catalogue (produit, fork) : posé par
// Insurance::Catalog::IgnoredSwitchComponent sur un bouton role="switch".
//
// Au clic : pose (ou retire) le cookie insurance_catalog_ignored=1, par navigateur, un an, puis recharge la page sur
// place (`Turbo.visit`, action replace) : le serveur relit le cookie (Insurance::Catalog::Pages.show_ignored?) et la
// liste des pages change — les modules que le produit ignore gagnent ou perdent leurs pages et leurs entrées au
// sommaire. Masquer depuis la page d'un module ignoré mène à la Présentation (elle n'existera plus).
//
// Les voisines déjà chargées sont gelées par common.ts (`src` retiré, contenu greffé tel quel dans le rendu suivant,
// cf. initializeLazyTurboFrames) : elles garderaient l'ancienne liste (lien « Page suivante », frame d'après). On les
// dégèle avant la visite : le rendu qui suit les recharge.
//
// Valeurs : `on`, l'état lu par le serveur ; `overviewUrl`, la Présentation de la fiche ; `capabilities`, les segments
// d'adresse (clés française et anglaise) des modules ignorés.
const COOKIE = "insurance_catalog_ignored"
const ONE_YEAR = 60 * 60 * 24 * 365
// Page d'une capacité : …/catalogue-produits/<code>[/forks/<n°>]/<capacité>[/<sous-onglet>].
const CAPABILITY_PAGE = /\/catalogue-produits\/[^/]+(?:\/forks\/\d+)?\/([^/]+)(?:\/[^/]+)?\/?$/

export default class extends Controller {
  static values = { on: Boolean, overviewUrl: String, capabilities: Array }

  toggle() {
    const on = !this.onValue
    const attributes = ["path=/", `max-age=${on ? ONE_YEAR : 0}`, "SameSite=Lax"]
    if (window.location.protocol === "https:") attributes.push("Secure")
    document.cookie = [`${COOKIE}=${on ? "1" : ""}`, ...attributes].join("; ")

    this.onValue = on
    this.element.setAttribute("aria-checked", String(on))
    this.thawPages()
    Turbo.visit(this.destination(on), { action: "replace" })
  }

  destination(on) {
    if (!on && this.overviewUrlValue && this.onIgnoredPage()) return this.overviewUrlValue

    return window.location.href
  }

  onIgnoredPage() {
    const match = CAPABILITY_PAGE.exec(window.location.pathname)
    return Boolean(match) && match[1] !== "forks" && this.capabilitiesValue.includes(match[1])
  }

  thawPages() {
    const root = this.element.closest("[data-controller~='continuous-pages']") ?? document
    for (const frame of root.querySelectorAll("turbo-frame[data-continuous-pages-target~='frame']")) {
      for (const node of [frame, ...frame.querySelectorAll("turbo-frame")]) {
        delete node.dataset.lazyLoaded
        node.removeAttribute("complete")
      }
    }
  }
}
